import React from "react";
import { useTranslation } from "react-i18next";

const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto p-8 bg-light-beige text-lightbg-default">
      <h1 className="text-3xl font-bold mb-4">{t("terms-of-service.title")}</h1>

      <p className="my-4">Last updated: December 7, 2024</p>

      <p className="my-4">
        Please read these Terms of Service ("Terms") carefully before using the
        Promptly Done website (the "Service") operated by [Your Company Name]
        ("us", "we", or "our").
      </p>

      <h2 className="text-xl font-semibold my-4">1. Acceptance of Terms</h2>

      <p className="my-4">
        By accessing or using the Service, you agree to be bound by these Terms.
        If you disagree with any part of the Terms, then you may not access the
        Service.
      </p>

      <h2 className="text-xl font-semibold my-4">2. Use of the Service</h2>

      <p className="my-4">
        The Service allows you to create detailed prompts for AI chatbots. You
        are responsible for the prompts you create and how you use them. You
        agree not to use the Service:
      </p>

      <ul className="list-disc ml-8 my-4">
        <li>For any illegal or unauthorized purpose.</li>
        <li>To create prompts that are harmful, abusive, or discriminatory.</li>
        <li>To impersonate any person or entity.</li>
        <li>To violate any third-party rights.</li>
      </ul>

      <h2 className="text-xl font-semibold my-4">3. Intellectual Property</h2>

      <p className="my-4">
        The Service and its original content, features, and functionality are
        and will remain the exclusive property of [Your Company Name] and its
        licensors. The Service is protected by copyright, trademark, and other
        laws of both the [Your Country] and foreign countries.
      </p>

      <h2 className="text-xl font-semibold my-4">4. Disclaimer</h2>

      <p className="my-4">
        The Service is provided "as is" without warranty of any kind, express or
        implied, including but not limited to the implied warranties of
        merchantability, fitness for a particular purpose, and non-infringement.
        We do not guarantee the accuracy, completeness, or usefulness of the
        Service, and we will not be liable for any errors or omissions in the
        Service.
      </p>

      <h2 className="text-xl font-semibold my-4">5. Limitation of Liability</h2>

      <p className="my-4">
        In no event shall [Your Company Name], its directors, officers,
        employees, affiliates, agents, contractors, or licensors be liable for
        any direct, indirect, incidental, special, consequential, or punitive
        damages, including without limitation, loss of profits, data, use,
        goodwill, or other intangible losses, arising out of or relating to your
        use of or inability to use the Service.
      </p>

      <h2 className="text-xl font-semibold my-4">6. Changes to the Terms</h2>

      <p className="my-4">
        We reserve the right to modify these Terms at any time in our sole
        discretion. If we make material changes to these Terms, we will post the
        updated Terms on the Service. Your continued use of the Service
        following the posting of revised Terms means that you accept and agree
        to the changes.
      </p>

      <h2 className="text-xl font-semibold my-4">7. Governing Law</h2>

      <p className="my-4">
        These Terms shall be governed and construed in accordance with the laws
        of [Your State/Province], [Your Country], without regard to its conflict
        of law provisions.
      </p>

      <h2 className="text-xl font-semibold my-4">8. Contact Us</h2>

      <p className="my-4">
        If you have any questions about these Terms, please contact us at [Your
        Email Address].
      </p>
    </div>
  );
};

export default TermsOfService;
